<template>
  <div class=""
    @click="openRow" :class="{'stat-ligne' : isTotal, 'is-radius-large' : !isTotal}">
    <div v-if="!isTotal" class="is-radius-top-left-large is-radius-top-right-large" :class="{ 'over' : sellers.length }"></div>
    <div class="columns is-gapless">
      <div class="columns column is-2 is-vcentered is-border-right">
        <div class="column is-paddingless-right is-padding-top is-padding-bottom is-padding-left-small">
          <strong v-if="entity.name">{{entity.name}}</strong>
          <strong v-else-if="entity.first_name">{{entity.first_name}} {{entity.last_name}}</strong>
          <span v-if="sellers && sellers.length > 1">
            <span class="is-size-6">({{sellers.length}} vendeurs)</span>
          </span>
        </div>
      </div>

      <div class="columns column is-2 is-border-right is-vcentered">
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{data.total.R0}}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{data.total.R1}}
        </div>
        <div class="column is-3 is-paddingless-righ is-padding-bottom-small is-padding-left-small">
          {{data.total.R2}}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{data.total.R3}}
        </div>
      </div>

      <div class="columns column is-2 is-border-right is-vcentered">
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{data.done.R0}}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{data.done.R1}}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{data.done.R2}}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{data.done.R3}}
        </div>
      </div>


      <div class="columns column is-1 is-border-right">
        <div class="column is-paddingless-right is-paddingless-left has-text-centered">
          {{data.cancel.count}}
        </div>
      </div>

      <div class="columns column is-one-fifth is-border-right">
        <div class="column is-4 is-paddingless-right is-padding-left-small">
          <span v-if="data.done.R0R1">{{data.done.R0R1}}%</span>
          <span v-else>--</span>
        </div>
        <div class="column is-4 is-paddingless-right is-padding-left-small">
          <span v-if="data.done.R1R2">{{data.done.R1R2}}%</span>
          <span v-else>--</span>
        </div>
        <div class="column is-4 is-paddingless-right is-padding-left-small">
          <span v-if="data.done.R2R3">{{data.done.R2R3}}%</span>
          <span v-else>--</span>
        </div>
      </div>
      <div class="columns column is-2">
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          <span v-if="futureData">{{futureData.total.R0}}</span>
          <span v-else>--</span>
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          <span v-if="futureData">{{futureData.total.R1}}</span>
          <span v-else>--</span>
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          <span v-if="futureData">{{futureData.total.R2}}</span>
          <span v-else>--</span>
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          <span v-if="futureData">{{futureData.total.R3}}</span>
          <span v-else>--</span>
        </div>
      </div>

      <div class="lastColumn column is-narrow has-text-centered actions is-padding-right-xsmall is-padding-left-xsmall is-padding-top-small is-padding-bottom-small">
        <button v-if="!isTotal && canBeRemove" @click="remove" class="button is-circle is-small">
          <i class="fal fa-times"></i>
        </button>
      </div>
    </div>
    <div class="stat-detail is-size-6 is-border-top is-border-dashed" v-if="isOpen">
      <div v-for="seller in sellers" class="columns is-gapless" :key="seller.pk">
        <div class="columns column is-2 is-vcentered is-border-right">
          <div class="column is-paddingless-right is-padding-top is-padding-bottom is-padding-left-large">
            <span class="is-margin-left-small">
              {{seller.first_name}} {{seller.last_name}}<br>
            </span>
          </div>
        </div>
        <div class="columns column is-2 is-border-right">
          <div class="column is-3 is-paddingless-right is-padding-left-small">
            {{seller._stats.rdvs.total.R0}}
          </div>
          <div class="column is-3 is-paddingless-right is-padding-left-small">
            {{seller._stats.rdvs.total.R1}}
          </div>
          <div class="column is-3 is-paddingless-righ is-padding-bottom-small is-padding-left-small">
            {{seller._stats.rdvs.total.R2}}
          </div>
          <div class="column is-3 is-paddingless-right is-padding-left-small">
            {{seller._stats.rdvs.total.R3}}
          </div>
        </div>

        <div class="columns column is-2 is-border-right">
          <div class="column is-3 is-paddingless-right is-padding-left-small">
            {{seller._stats.rdvs.done.R0}}
          </div>
          <div class="column is-3 is-paddingless-right is-padding-left-small">
            {{seller._stats.rdvs.done.R1}}
          </div>
          <div class="column is-3 is-paddingless-right is-padding-left-small">
            {{seller._stats.rdvs.done.R2}}
          </div>
          <div class="column is-3 is-paddingless-right is-padding-left-small">
            {{seller._stats.rdvs.done.R3}}
          </div>
        </div>


        <div class="columns column is-1 is-border-right">
          <div class="column is-paddingless-right is-paddingless-left has-text-centered">
            {{seller._stats.rdvs.cancel.count}}
          </div>
        </div>

        <div class="columns column is-one-fifth is-border-right">
          <div class="column is-4 is-paddingless-right is-padding-left-small">
            <span v-if="seller._stats.rdvs.done.R0R1">{{seller._stats.rdvs.done.R0R1}}%</span>
            <span v-else>--</span>
          </div>
          <div class="column is-4 is-paddingless-right is-padding-left-small">
            <span v-if="seller._stats.rdvs.done.R1R2">{{seller._stats.rdvs.done.R1R2}}%</span>
            <span v-else>--</span>
          </div>
          <div class="column is-4 is-paddingless-right is-padding-left-small">
            <span v-if="seller._stats.rdvs.done.R2R3">{{seller._stats.rdvs.done.R2R3}}%</span>
            <span v-else>--</span>
          </div>
        </div>

        <div class="columns column is-2">
          <div class="column is-3 is-paddingless-right is-padding-left-small">
            <span v-if="seller._stats && seller._stats.futuresRdvs">
              {{seller._stats.futuresRdvs.total.R0}}
            </span>
            <span v-else>--</span>
          </div>
          <div class="column is-3 is-paddingless-right is-padding-left-small">
             <span v-if="seller._stats && seller._stats.futuresRdvs">
              {{seller._stats.futuresRdvs.total.R1}}
            </span>
            <span v-else>--</span>
          </div>
          <div class="column is-3 is-paddingless-right is-padding-left-small">
            <span v-if="seller._stats && seller._stats.futuresRdvs">
              {{seller._stats.futuresRdvs.total.R2}}
            </span>
            <span v-else>--</span>
          </div>
          <div class="column is-3 is-paddingless-right is-padding-left-small">
             <span v-if="seller._stats && seller._stats.futuresRdvs">
              {{seller._stats.futuresRdvs.total.R3}}
            </span>
            <span v-else>--</span>
          </div>
        </div>
        <div class="column lastColumn has-text-centered actions is-padding-right-xsmall is-padding-left-xsmall is-padding-top-small is-padding-bottom-small">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swatches from 'vue-swatches'
  import {orderBy} from 'lodash'
  import VariationIndice from '../../utils/VariationIndice'
  import StatValue from '../../utils/StatValue'

  export default {
    name: 'RdvEntityRow',
    components: {
      VariationIndice,
      Swatches,
      StatValue
    },
    props: {
      entity: {
        type: Object,
        required: true
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      isTotal: {
        type: Boolean,
        default: false
      },
      canBeRemove: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        color: null
      }
    },
    computed: {
      entityColor () {
        return this.entity._color
      },
      inlineStyle () {
        return {
          backgroundColor: this.entityColor
        }
      },
      orderedSellers () {
        return orderBy(this.sellers, ['seller.first_name', 'seller.last_name'])
      },
      sellers () {
        if ('_sellers' in this.entity) {
          return Object.values(this.entity._sellers)
        } else {
          return []
        }
      },
      sellersName () {
        return this.sellers.map(x => {
          return x.first_name + ' ' + x.last_name
        }).join(', ')
      },
      data () {
        return this.entity._stats.rdvs
      },
      futureData () {
        return this.entity._stats.futuresRdvs
      },
      previousData () {
        return this.entity._stats.previousRdvs
      }
    },
    methods: {
      openRow () {
        if (!this.sellers || !this.sellers.length) return
        this.$emit('open', this.entity)
      },
      remove () {
        this.$emit('remove', this.entity)
      },
      setColor (value) {
        this.$emit('setColor', this.entity, value)
      }
    },
    created () {
      this.color = this.entity._color
    }
  }
</script>

<style>
  .lastColumn {
    flex: none;
    width: 47px;
  }
</style>



// WEBPACK FOOTER //
// src/components/statistics/rdv/RdvEntityRow.vue